import React from 'react';
import Button from '@mui/material/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ButtonStartIcon = React.forwardRef(({
  disabled,
  children,
  loading,
  startIcon,
  className,
  onClick,
  variant,
  color,
  style,
  size = 'small',
  component
}, ref) => {
  return (
    <Button
      ref={ref}
      component={component}
      size={size}
      style={style}
      disabled={disabled || loading}
      className={className}
      onClick={onClick}
      variant={variant || 'contained'}
      color={color || 'primary'}
      startIcon={loading ? <FontAwesomeIcon  icon='circle-notch' spin /> : <FontAwesomeIcon  icon={startIcon} /> }
    >
      {children}
    </Button>
  )
});

ButtonStartIcon.displayName = 'ButtonStartIcon';

export default ButtonStartIcon